/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.6",
    versionName: "0.2.0-nightly.2025.11.6",
    versionChannel: "nightly",
    buildDate: "2025-11-06T00:07:40.242Z",
    commitHash: "999b5c7d8646ce412a1599a5e2c37200af2b88f3",
};
